import { AutogenLayoutSendLoad } from "./autogen/AutogenLayoutSendLoad";
import { DataSourceMode, Layout, SaveButton, SlideoutDecorator, Snackbar, Toast, DataSourceExecutionEvent, DataSourceAction, Button, SlideoutDecoratorProps, Textbox, DataSource } from "@mcleod/components";
import { Api } from "@mcleod/core";

interface SendLoadProps {
    equipmentGroupId: string;
    movementId: string;
}

export class SendLoad extends AutogenLayoutSendLoad {
    public movementId: string;
    public sendButton: SaveButton | Button;

    onLoad(): void | Promise<void> {
        this.sourceEquipmentGroup.mode = DataSourceMode.ADD;
    }

    static showSlideout(props: SendLoadProps, slideoutProps?: Partial<SlideoutDecoratorProps>) {
        const { equipmentGroupId, movementId } = props;
        const self = Layout.getLayout("lme/dispatch/asset/SendLoad") as SendLoad;
        const saveButton = SaveButton.create({
            caption: "Send Now",
            rowBreak: false,
            onClick: async () => {
                const success = await self.send();
                if (success)
                    self.slideOut().then(() => Toast.showSuccessToast("Load Sent Successfully"));
            }
        });
        const slideout = new SlideoutDecorator({
            layout: self,
            fillHeight: true,
            width: "20%",
            title: "Send Load",
            addlComponents: [saveButton],
            doAfterSlideIn: async () => {
                if (equipmentGroupId) {
                    await self.sourceEquipmentGroup.search({ id: equipmentGroupId });
                    const response = await SendLoad.validateUnits(
                        self.sourceEquipmentGroup.activeRow.get("tractor_id"),
                        self.sourceEquipmentGroup.activeRow.get("driver_id"),
                        self.sourceEquipmentGroup.activeRow.get("driver2_id")
                    );
                    if (response.data) {
                        self.displayValidMcUnits(response.data[0]);
                    }
                } else {
                    self.textboxTractorId.visible = true;
                }
                self.movementId = movementId;
                self.sendButton = saveButton;
            },
            ...slideoutProps
        });
    }

    async send(): Promise<boolean> {
        try {
            this.sendButton.busy = true;
            await Api.post("lme/dispatch/asset/zmit-load",
            {
                movement_id: this.movementId,
                unit_id: this.getValidUnit(),
                ...this.sourceZmitLoad.activeRow.data
            });
            return true;
        } catch (ex) {
            Snackbar.showWarningSnackbar(ex.messages[0]);
        } finally {
            this.sendButton.busy = false;
        }
        return false;
    }

    /** This is an event handler for the afterExecution event of sourceZmitLoad. */
    sourceZmitLoadAfterExecution(event: DataSourceExecutionEvent) {
        if (event.getAction() === DataSourceAction.SEARCH) {
            this.panelZmitSwitches.visible = event.dataSource.activeRow.getBoolean("fuel_opt_active");
        }
    }

    static validateUnits(tractor_id: string, driver_id: string, driver2_id: string | null): Promise<any> {
        return Api.post("lme/dispatch/mobilecomm/validate-mc-units", {
            tractor_id, driver_id, driver2_id
        });
    }

    displayValidMcUnits(validationRes: any) {
        const { valid_tractor, valid_driver, valid_driver2 } = validationRes;
        this.textboxTractorId.visible = valid_tractor || (!valid_tractor && !valid_driver && !valid_driver2);
        this.textboxDriver.visible = !valid_tractor && (valid_driver || valid_driver2);
        if (!valid_tractor && !valid_driver && valid_driver2) {
            this.sourceEquipmentGroup.rowIndex = 1; // use driver2
        }
    }

    getValidUnit() {
        if (this.textboxTractorId.visible) { // default to tractor unit if valid
            return this.sourceEquipmentGroup.activeRow.get("tractor_id");
        } else {
            return this.sourceEquipmentGroup.activeRow.get("driver_id"); // this accounts for case where driver2 is valid as rowIndex should be set to 1
        }
    }
}
